import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';

@Component({
  selector: 'app-asecs',
  standalone: true,
  imports: [MatCardModule, MatFormFieldModule, MatInputModule, FormsModule, MatCheckboxModule, MatSliderModule],
  templateUrl: './asecs.component.html',
  styleUrl: './asecs.component.scss',
})
export class AsecsComponent {
  disabled = false;
  max = 30;
  min = 2.5;
  showTicks = true;
  step = 2.5;
  thumbLabel = true;
  value = 2.5;
  value2 = undefined;
}
